import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss']
})
export class PromptComponent implements OnInit {
  inputControl = new FormControl('', [Validators.required]);

  constructor(
    private $dialogRef: MatDialogRef<PromptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PromptDialog
  ) { }

  ngOnInit(): void {
  }

  onConfirm(): void {
    if (this.inputControl.valid) {
      this.$dialogRef.close(this.inputControl.value);
    }
  }

  onCancel(): void {
    this.$dialogRef.close(null);
  }
}

export interface PromptDialog {
  message: string;
  title: string;
  placeholder: string;
  okBtnTxt: string;
  cancelBtnTxt: string;
}